/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type WorkingModeActivityPhase = (typeof WorkingModeActivityPhase)[keyof typeof WorkingModeActivityPhase];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingModeActivityPhase = {
  module_policies: 'module_policies',
  structure: 'structure',
  essays: 'essays',
} as const;
